import { channelPartnerKeyScopeKey as e } from "./channelPartnerKeyScopeKey.mjs";
import { useTrEnumNamespace as t } from "./useTrEnumNamespace.mjs";
import { useCallback as n } from "react";
//#region src/enums/useTrChannelPartnerKeyScopeDescription.ts
var r = () => {
	let r = t("channelPartnerKeyScopeDescription");
	return n((t) => {
		let n = e(t), i = r(n);
		return i === n ? "" : i;
	}, [r]);
};
//#endregion
export { r as useTrChannelPartnerKeyScopeDescription };
